import React from 'react';
import { BASE_HOLDERS, CALL_MODES } from '../domain/constants';

// Il giocatore estratto, in attesa che il banditore faccia partire il timer.
//
// Prende la forma della scheda del lotto, senza orologio: fra l'estrazione e
// l'asta vera il giocatore e' lo stesso, e cambiargli aspetto proprio nel
// momento in cui tutti lo stanno leggendo costringerebbe a ritrovarlo.

export default function PendingCallPanel({
    pick,
    player,
    callMode,
    baseHolder,
    turnHolder,
    isAuctioneer,
    skippedCount,
    onStart,
    onRedraw,
    onRestore,
}) {
    if (!pick) {
        return (
            <section className="panel">
                <div className="panel-header">
                    <h2 className="panel-title">Chiamata</h2>
                </div>
                <div className="panel-body">
                    <p className="u-dim">
                        Nessun giocatore libero da estrarre in questo ruolo.
                    </p>
                </div>
            </section>
        );
    }

    const fullName = player?.['Nome Completo'] ?? pick.player_name;
    const surname = player?.Cognome || fullName;
    const drawnByChance = callMode === CALL_MODES.RANDOM;
    const heading = {
        [CALL_MODES.RANDOM]: 'Estratto a sorte',
        [CALL_MODES.FVM]: 'Il più caro rimasto',
        [CALL_MODES.ALPHA]: 'Il primo in ordine alfabetico',
    }[callMode] ?? 'Prossima chiamata';

    return (
        <section className="panel">
            <div className="panel-header">
                <h2 className="panel-title">
                    {heading}
                </h2>
            </div>
            <div className="panel-body stack">
                <div className="lot lot--settled">
                    <h3 className="lot-name">{surname}</h3>
                    <p className="lot-meta">
                        <span className="badge badge--role" data-role={pick.role}>
                            {pick.role}
                        </span>
                        {player?.Squadra && <span>{player.Squadra}</span>}
                    </p>
                    <p className="u-dim">
                        {baseHolder === BASE_HOLDERS.TURN
                            ? `Base 1, a ${turnHolder?.name ?? 'chi e di turno'}.`
                            : 'Base a nessuno: si rilancia da 1.'}
                    </p>
                </div>

                {isAuctioneer ? (
                    <div className="panel-actions">
                        <button type="button" className="btn btn--go" onClick={onStart}>
                            Avvia asta
                        </button>
                        {/* Nelle modalita a lista (FVM, alfabetico) non si
                            estrae niente: si scorre verso il basso, e chi
                            scorre deve poter risalire. Senza il ritorno i
                            saltati sembravano spariti fino al cambio di ruolo. */}
                        <button type="button" className="btn btn--ghost" onClick={onRedraw}>
                            {drawnByChance ? 'Ri-estrai' : 'Salta'}
                        </button>
                        {!drawnByChance && (
                            <button
                                type="button"
                                className="btn btn--ghost"
                                disabled={!skippedCount}
                                title={
                                    skippedCount
                                        ? `${skippedCount} saltati tornano disponibili`
                                        : 'Non hai saltato nessuno'
                                }
                                onClick={onRestore}
                            >
                                Torna in cima
                            </button>
                        )}
                    </div>
                ) : (
                    <p className="u-dim">
                        In attesa che il banditore faccia partire il timer.
                    </p>
                )}
            </div>
        </section>
    );
}
